/* mad-wizard-cart.js: line-item properties, /cart/add.js and /cart/change.js, header bubble and
   cart events, the "Review your door" step, the confirmation view, the raw of older quick saves (quickRaw, kept for
   the tests' legacy fixtures; no page calls it), and the product page glue ("Install Ready from $X", sticky bar
   price). Extends window.MadWizard.
   Release B (Seth 2026-10-12): "Review your door" shows every choice and the price before the door goes in, and its
   button "Add to estimate" (or "Update this door") is the only one that saves; nothing reaches the estimate before it.
   A plain /cart line opened with "Price additional services" (mode 'cart-move') leaves the cart first and then joins
   the estimate, every unit of it (R01, QA2-11); an antique is never both payable and on the estimate.
   Seth 2026-10-11, one place to call (at the end of the quote request): no phone number in the form's messages. */
(function () {
  'use strict';
  var W = window.MadWizard; if (!W || W.cartLoaded) return; W.cartLoaded = true;
  var doc = document, cfg = W.config || {}, h = W.h, money = W.money;
  function E() { return window.MADEstimate; }
  function BOOK() { return window.MAD_PRICE_BOOK || {}; }
  var phone = cfg.phone || '(337) 273-0189', phoneHref = cfg.phoneHref || 'tel:+13372730189', cartUrl = cfg.cartUrl || '/cart';

  var L = {
    application: { standard_hinged: 'Standard hinged', sliding_barn: 'Sliding barn', pocket_door: 'Pocket door', bifold: 'Bi-fold', decorative: 'Decorative' },
    pairOp: { both_active: 'Both doors open', active_fixed: 'One active, one fixed', not_sure: 'Not sure, on the call' },
    restore: { restore_remove_hardware: 'Remove hardware', restore_square_edges: 'Square edges', restore_patch_mortise: 'Patch mortise/keys', restore_fix_cracks: 'Fix cracks', restore_light_sand: 'Light sand', restore_heavy_sand: 'Heavy sand', restore_full: 'Full restoration' },
    wax: { none: 'None', clear: 'Clear', clear_tint: 'Clear Tint', stripped_pine: 'Stripped Pine', rugger_brown: 'Rugger Brown' },
    glass: { remove: 'Remove panels', clear_tempered: 'Clear tempered', diamond_pattern: 'Diamond pattern', english_pattern: 'English pattern' },
    prehang: { yes: 'Yes', no: 'No, slab only', not_sure: 'Not sure' },
    wall: { '4_9_16': '4 9/16 in', '6_9_16': '6 9/16 in', other: 'Other', not_sure: 'Not sure' },
    swing: { not_sure: 'Not sure', lhis: 'Left hand in-swing', lhos: 'Left hand out-swing', rhis: 'Right hand in-swing', rhos: 'Right hand out-swing', lhais: 'Left hand active in-swing', lhaos: 'Left hand active out-swing', rhais: 'Right hand active in-swing', rhaos: 'Right hand active out-swing', push: 'Push swing', pull: 'Pull swing' },
    hinge: { '': 'Not sure', brushed_nickel: 'Brushed Nickel', gold: 'Brushed Gold', matte_black: 'Matte Black', antique_bronze: 'Antique Bronze', other: 'Other' },
    latch: { magnetic: 'Magnetic', ball: 'Ball catch', no_latch: 'No latch' },
    grade: { not_sure: 'Not sure', prime_pine: 'Primed pine', stain_cypress: 'Stain-grade cypress' }
  };

  /* ---------- properties (section 8 of the contract) ---------- */
  function buildProperties(raw, product) {
    var p = {};
    p['Location'] = raw.int_ext === 'exterior' ? 'Exterior' : 'Interior';
    p['Application'] = L.application[raw.application] || 'Standard hinged';
    if (raw.pair_operation) p['Pair Operation'] = L.pairOp[raw.pair_operation] || raw.pair_operation;
    if (raw.rough_opening) p['Rough Opening'] = raw.rough_opening;
    if (raw.finished_opening) p['Finished Opening'] = raw.finished_opening;
    if (raw.not_measured === '1') p['Rough Opening'] = 'Not measured yet';
    if (raw.fit_readout && E().FIT_TEXT[raw.fit_readout]) p['Fit'] = E().FIT_TEXT[raw.fit_readout];
    p['Resize'] = raw.resize === 'yes' ? 'Yes' : 'None';
    if (raw.resize === 'yes' && raw.target_width) p['Target Width'] = raw.target_width + ' in';
    if (raw.resize === 'yes' && raw.target_height) p['Target Height'] = raw.target_height + ' in';
    if (raw.room_tag) p['Room / Plan Tag'] = raw.room_tag;
    if (raw.opening_photo) p['Opening Photo'] = raw.opening_photo;
    if (raw.door_kind !== 'handcrafted') {
      var items = E().RESTORE_KEYS.filter(function (k) { return raw[k] === '1'; }).map(function (k) { return L.restore[k]; });
      p['Restoration'] = items.length ? items.join(', ') : 'None';
    }
    p['Wax Finish'] = L.wax[raw.wax_finish || 'none'] || 'None';
    if (raw.glass_work && raw.glass_work !== 'none') p['Glass Work'] = L.glass[raw.glass_work] || raw.glass_work;
    if (raw.glass_panes === 'not_sure') p['Glass Panes'] = 'Sizes on the call';
    else if (raw.glass_panes) p['Glass Panes'] = raw.glass_panes + (raw.glass_panes === '1' ? ' pane, ' : ' panes, ') + raw.glass_pane_width + ' x ' + raw.glass_pane_height + ' in';
    if (raw.glass_compliance === '1') p['Glass Safety Acknowledged'] = 'Yes';
    p['Pre-Hanging'] = L.prehang[raw.jamb_needed] || 'No, slab only';
    if (raw.jamb_needed === 'yes') {
      p['Jamb Type'] = String(raw.jamb_type || '').replace(/_/g, ' ');
      p['Jamb Depth'] = raw.wall_depth === 'other' && raw.wall_depth_custom ? raw.wall_depth_custom + ' in' : (L.wall[raw.wall_depth] || 'Not sure');
      p['Swing'] = L.swing[raw.swing] || 'Not sure';
      p['Hinge Color'] = L.hinge[raw.hinge_color || ''] || raw.hinge_color;
      if (raw.int_ext !== 'exterior') p['Latch'] = L.latch[raw.latch_type] || 'Magnetic';
      p['Jamb Grade'] = L.grade[raw.jamb_grade] || 'Not sure';
      if (raw.details_deferred === 'yes') p['Install details'] = 'Ask me on the call';
    }
    if (raw.estimate_total) p['Estimate before freight'] = E().money(Number(raw.estimate_total));
    p['_raw'] = JSON.stringify(raw);
    return p;
  }

  /* ---------- cart calls ---------- */
  function post(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function fetchCart() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function fail(res, fallback) {
    return res.json().catch(function () { return {}; }).then(function (err) { throw new Error(err.description || err.message || fallback); });
  }
  /* The header icon: the cart's count goes on the icon's marker and assets/mad-cart-count.js adds the doors on the
     estimate (Release B, B3); without that script the bubble shows the cart alone, as before. */
  function updateCartIcon(cart) {
    try {
      var link = doc.getElementById('cart-icon-bubble'); if (!link) return;
      var C = window.MadCartCount, n = cart.item_count;
      if (C && typeof C.setCart === 'function') { C.setCart(n); return; }
      var bubble = link.querySelector('.cart-count-bubble');
      if (n > 0) {
        if (!bubble) { bubble = doc.createElement('div'); bubble.className = 'cart-count-bubble'; link.appendChild(bubble); }
        bubble.innerHTML = (n < 100 ? '<span aria-hidden="true">' + n + '</span>' : '') + '<span class="visually-hidden">' + n + (n === 1 ? ' item' : ' items') + '</span>';
      } else if (bubble) bubble.remove();
    } catch (_) { /* cosmetic only */ }
  }
  function afterCartChange(cart) {
    updateCartIcon(cart);
    doc.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
    doc.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    if (typeof window.publish === 'function') { try { window.publish((window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) || 'cart-update', { source: 'mad-wizard', cartData: cart }); } catch (_) { /* ignore */ } }
  }
  function currentMode(fallback) { var st = W.state(); return W.isOpen() && st ? st.mode : fallback; }

  /* Plan 5.4: with the estimate list on, a door priced with services goes to the list
     (assets/mad-estimate-list.js), never into the payable cart. The method names stay so every
     caller and event keeps working; the event's cart is the list in /cart.js shape. */
  function EL() { var L = window.MadEstimateList; return L && L.enabled ? L : null; }
  function listResult(list, id) {
    var cart = list.toCart(), item = cart.items.filter(function (i) { return i.key === id; })[0] || null;
    return { line: item, cart: cart };
  }

  /* One of one: the estimate entry an antique already has (another tab may have added it since the form opened) */
  function antiqueEntry(list, product) {
    return list && typeof list.findByVariant === 'function' && E().detectDoorKind(product || {}) === 'antique' ? list.findByVariant(product.variantId) : null;
  }
  function addToCart(product, raw, mode) {
    var props = buildProperties(raw, product);
    var list = EL();
    if (list) {
      /* an antique already on the estimate is updated, never added twice (out.replaced: no add_to_cart is sent) */
      var same = antiqueEntry(list, product);
      var entry = same ? list.update(same.id, product, raw, props) : list.add(product, raw, props), out = listResult(list, entry.id);
      out.replaced = !!same;
      W.emit('mad:wizard:added', { mode: mode || currentMode('pdp'), product: product, raw: raw, line: out.line, cart: out.cart, estimateList: true, replaced: !!same });
      return Promise.resolve(out);
    }
    return post('/cart/add.js', { id: Number(product.variantId), quantity: 1, properties: props }).then(function (res) {
      if (!res.ok) return fail(res, 'We could not add this door. Please try again.');
      return res.json();
    }).then(function (line) {
      return fetchCart().then(function (cart) {
        afterCartChange(cart);
        W.emit('mad:wizard:added', { mode: mode || currentMode('pdp'), product: product, raw: raw, line: line, cart: cart });
        return { line: line, cart: cart };
      });
    });
  }
  function findLine(cart, product, props) {
    return (cart.items || []).filter(function (i) { return i.variant_id === Number(product.variantId) && i.properties && i.properties._raw === props._raw; })[0] || null;
  }
  /* Codex final review R01 (2026-09-26): a cart line keeps every unit when its choices change. /cart/change.js sets
     the quantity it is given, so it is sent the line's own quantity (the row's data-mad-quantity), never 1. */
  function cartQuantity(lineKey) {
    var rows = doc.querySelectorAll('tr.cart-item[data-mad-line-key]');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].getAttribute('data-mad-line-key') !== lineKey) continue;
      var n = parseInt(rows[i].getAttribute('data-mad-quantity'), 10);
      return n > 0 ? n : 1;
    }
    return 1;
  }
  /* An estimate entry's id (MadEstimateList: 'e' and base 36), never a Shopify line key ("<variant>:<hash>") */
  function isListId(key) { return /^e[0-9a-z]+$/.test(String(key || '')); }
  function updateLine(lineKey, product, raw, mode) {
    var props = buildProperties(raw, product);
    var list = EL();
    if (list && (list.get(lineKey) || isListId(lineKey))) {
      /* An entry removed meanwhile (another tab) goes back on the estimate (an antique updates the entry it has): never
         through /cart/add.js, which would put a door with shop work in the payable cart (Release B). */
      var same = list.get(lineKey) ? null : antiqueEntry(list, product);
      var id = list.get(lineKey) ? lineKey : same ? same.id : null;
      if (id) list.update(id, product, raw, props); else id = list.add(product, raw, props).id;
      var out = listResult(list, id);
      W.emit('mad:wizard:updated', { mode: mode || currentMode('cart-edit'), product: product, raw: raw, lineKey: id, line: out.line, cart: out.cart, estimateList: true });
      return Promise.resolve(out);
    }
    var qty = cartQuantity(lineKey);
    return post('/cart/change.js', { id: lineKey, quantity: qty, properties: props }).then(function (res) {
      if (!res.ok) throw new Error('change failed');
      return res.json();
    }).then(function (cart) {
      var line = findLine(cart, product, props); if (!line) throw new Error('line not found after change');
      return { line: line, cart: cart };
    }).catch(function () {
      return post('/cart/change.js', { id: lineKey, quantity: 0 }).then(function () { return post('/cart/add.js', { id: Number(product.variantId), quantity: qty, properties: props }); })
        .then(function (res) { if (!res.ok) return fail(res, 'We could not update this door. Please try again.'); return res.json(); })
        .then(function (line) { return fetchCart().then(function (cart) { return { line: line, cart: cart }; }); });
    }).then(function (out) {
      afterCartChange(out.cart);
      W.emit('mad:wizard:updated', { mode: mode || currentMode('cart-edit'), product: product, raw: raw, lineKey: lineKey, line: out.line, cart: out.cart });
      return out;
    });
  }
  function removeLine(lineKey) {
    var list = EL();
    if (list && list.get(lineKey)) {
      list.remove(lineKey);
      var cart = list.toCart();
      W.emit('mad:wizard:removed', { lineKey: lineKey, cart: cart, estimateList: true });
      return Promise.resolve(cart);
    }
    return post('/cart/change.js', { id: lineKey, quantity: 0 }).then(function (res) { if (!res.ok) return fail(res, 'We could not remove this door.'); return res.json(); })
      .then(function (cart) { afterCartChange(cart); W.emit('mad:wizard:removed', { lineKey: lineKey, cart: cart }); return cart; });
  }

  /* ---------- raw helpers for the cart (contract 7.6) ---------- */
  function parseRaw(item) { try { var s = item && item.properties && item.properties._raw; return s ? JSON.parse(s) : null; } catch (_) { return null; } }
  /* The raw the cart's three quick questions saved until Release B (details_deferred yes, no wax): no page calls it
     since the quick questions were retired (2026-10-12); kept so the tests can build the older saves that /cart must
     still show with "Details needed" and open with "Add details". */
  function quickRaw(product, a) {
    a = a || {};
    var st = W.buildState({ product: product, mode: 'quick' });
    Object.assign(st.raw, { int_ext: a.intExt || 'interior', application: 'standard_hinged', opening_type: 'rough', opening_width: a.openingWidth || '', opening_height: a.openingHeight || '',
      not_measured: a.notMeasured ? '1' : '', jamb_needed: a.jambNeeded || 'no', details_deferred: 'yes', resize: '' });
    var raw = W.buildRaw(st);
    // Quick mode prices the resize when the readout says so, unless the caller passed resize: 'no' (fitted locally).
    if (raw.fit_readout === 'resize') { st.raw.resize = a.resize === 'no' ? 'no' : 'yes'; raw = W.buildRaw(st); }
    E().RESTORE_KEYS.concat(['restore_tier', 'wax_finish', 'glass_work', 'glass_panes', 'glass_pane_width', 'glass_pane_height', 'glass_notes', 'glass_compliance']).forEach(function (k) { delete raw[k]; });
    // Sheet / cart quick keep original glass: antique + Glass tag needs the non-tempered ack when the caller collected it.
    if (st.kind === 'antique' && st.flags.glass && a.glassCompliance) {
      raw.glass_work = 'none';
      raw.glass_compliance = '1';
    }
    return raw;
  }
  function estimateForCartItem(item) {
    var raw = parseRaw(item); if (!raw) return null;
    var flags = { arched: /arched/.test(raw.jamb_type || ''), glass: !!raw.glass_work, iron: false };
    return E().estimate(raw, { doorPrice: (Number(item.final_price != null ? item.final_price : item.price) || 0) / 100, config: raw.door_config || 'single', flags: flags, kind: raw.door_kind || 'antique' }, BOOK());
  }

  /* ---------- the wizard's own submit and confirmation ---------- */
  function checkAvailable(product) {
    if (!product.handle) return Promise.resolve(true);
    return fetch('/products/' + product.handle + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (pj) {
      if (!pj) return true;
      var v = (pj.variants || []).filter(function (x) { return x.id === Number(product.variantId); })[0];
      return v ? v.available !== false : pj.available !== false;
    }).catch(function () { return true; });
  }
  /* The cart line of this antique, if it is in the Shopify cart too (bought as shown, or an older customized line):
     the form moves it, so a one of one door is never both payable and on the estimate (Release B). null when there is
     none, when the door is handcrafted, when the estimate list is off, or when the cart cannot be read. */
  function cartLineOf(product) {
    if (!EL() || E().detectDoorKind(product || {}) !== 'antique') return Promise.resolve(null);
    return fetchCart().then(function (cart) {
      return (cart.items || []).filter(function (i) { return Number(i.variant_id) === Number(product.variantId); })[0] || null;
    }).catch(function () { return null; });
  }
  /* QA2-11: the cart line goes first; the door joins the estimate only once it has left the cart, so a failed removal
     (a 500, Shopify's 429) adds nothing and leaves nothing in both places */
  function leaveCart(lineKey, door) {
    return removeLine(lineKey).catch(function () { throw new Error('We could not move ' + door + ' to your estimate. Nothing changed. Please try again.'); });
  }
  /* mode 'cart-move' (a plain /cart line, "Price additional services"): out of the cart first, then onto the estimate.
     Codex final review R01: every unit moves; N handcrafted doors on one line become N estimate doors, one line each,
     prepared in full before the cart is touched. An antique joins once; one already on the estimate (existingId) is
     updated. The 40-line limit is checked before the form opens (mad-quote-lines.js) and again here, before anything
     moves. With the estimate list off, the choices go on the cart line itself (updateLine keeps its quantity). */
  function moveToEstimate(st, product, raw) {
    var list = EL(), door = W.thisDoor(st);
    if (!list) return updateLine(st.lineKey, product, raw, 'cart-move');
    var existing = st.existingId ? list.get(st.existingId) : antiqueEntry(list, product);
    var n = existing ? 0 : st.kind === 'antique' ? 1 : Math.max(1, Number(st.units) || 1);
    var QL = window.MadQuoteLines, limit = QL && QL.QUOTE_LINE_LIMIT;
    if (n && QL && QL.quoteLineCount && QL.quoteLineCount(n) > limit) return Promise.reject(new Error('Your estimate holds up to ' + limit + ' doors. Send it first, then add more.'));
    var props, items = [];
    try {
      props = buildProperties(raw, product);
      for (var i = 0; i < n; i++) items.push({ product: product, raw: raw, properties: props });
    } catch (_) { return Promise.reject(new Error('Something went wrong. Nothing changed. Please try again.')); }
    return leaveCart(st.lineKey, door).then(function () {
      var added = existing ? [list.update(existing.id, product, raw, props)] : list.addAll(items);
      var id = added[0] && added[0].id, out = listResult(list, id);
      out.moved = n; out.updated = !!existing; out.id = id;
      W.emit('mad:wizard:added', { mode: 'cart-move', moved: n, product: product, raw: raw, line: out.line, cart: out.cart, estimateList: true, replaced: !!existing });
      return out;
    });
  }
  /* Only "Review your door" saves (Seth 2026-10-12): from any other step the button acts as Next. A required answer
     still missing anywhere (Add details may open past it) is asked first, on its own step, marked. */
  W.submit = function () {
    var st = W.state(), els = W.els(); if (!st) return;
    if (st.at !== 'review') { W.next(); return; }
    var gap = W.firstIncomplete(st);
    if (gap) { W.goTo(gap); W.validateCurrent(); return; }
    var raw = W.buildRaw(st), product = st.product, mode = st.mode, door = W.thisDoor(st), updating = W.updating(st), moved = false;
    els.submit.disabled = true; els.submit.setAttribute('aria-busy', 'true'); els.err.textContent = '';
    els.status.textContent = updating ? ('Updating ' + door) : 'Adding to your estimate';
    /* an antique opened from its card or the door page that is a plain cart line too leaves the cart first */
    var outOfCart = function () {
      return cartLineOf(product).then(function (line) { if (!line) return null; moved = true; return leaveCart(line.key, door); });
    };
    var run;
    try {
      if (mode === 'cart-move') run = moveToEstimate(st, product, raw);
      else if (mode === 'cart-edit') run = (st.ui.already ? outOfCart() : Promise.resolve()).then(function () { return updateLine(st.lineKey, product, raw, 'cart-edit'); });
      else run = checkAvailable(product).then(function (ok) {
        if (!ok) throw new Error('Sorry, ' + door + ' was just sold.');
        return outOfCart();
      }).then(function () { return addToCart(product, raw, mode); });
    } catch (err) { run = Promise.reject(err); }
    run.then(function (out) {
      st.ui.added = true;
      if (mode === 'pdp' && !moved && !(out && out.replaced)) {
        /* GA4 add_to_cart and Meta AddToCart as live's customize form sent them (no value unless an owner ticks
           mad_track_estimate_value), through window.madLead (snippets/mad-tracking.liquid; dry run on the preview).
           A card's add says so (source 'card'), which the owner switch "Count adds from the collection cards as add to
           cart" (mad_track_sheet_add_to_cart) decides. Moves and edits send none: the door was counted when it was
           bought as shown. */
        var detail = { id: String(product.variantId), name: product.title, value: Number(raw.estimate_total) || 0 };
        if (st.source === 'card') detail.source = 'card';
        try { if (window.madLead && typeof window.madLead.addToCart === 'function') window.madLead.addToCart(detail); } catch (_) { /* ignore */ }
      }
      els.status.textContent = '';
      /* an Edit from /cart, or a cart line priced with the estimate list off: the row shows the change */
      if ((mode === 'cart-edit' && !st.ui.already) || (mode === 'cart-move' && !EL())) { W.close('done'); return; }
      showConfirmation(st, raw, out);
    }).catch(function (e) {
      els.status.textContent = '';
      els.err.textContent = (e && e.message) || 'Something went wrong. Please try again.';
    }).then(function () { els.submit.disabled = false; els.submit.removeAttribute('aria-busy'); });
  };
  function showConfirmation(st, raw, out) {
    var els = W.els(), root = W.root(), est = W.estimateForRaw(raw, st.product);
    var name = st.product.name || E().doorLabel(st.product.title);
    var updated = !!(out && (out.updated || out.replaced)) || (st.mode === 'cart-edit' && st.ui.already), several = out && out.moved > 1 ? out.moved : 0;
    var title = several ? several + ' doors are on your estimate' : name + (updated ? ' is updated on your estimate' : ' is on your estimate');
    /* a moved /cart line is gone: focus goes to its first estimate row when the form closes */
    if (out && out.id && W.setOpener) W.setOpener('[data-mad-estimate-row][data-mad-line-key="' + out.id + '"] [data-mad-edit]');
    root.querySelectorAll('[data-mad-step]').forEach(function (p) { p.hidden = true; });
    els.foot.hidden = true; els.progress.textContent = 'Done';
    if (els.stepbar) els.stepbar.hidden = true;
    root.setAttribute('data-mad-at', 'done');
    var hold = holdFor(st);
    /* Seth 2026-10-08: the phone number stays in the footer, on Contact and in the phone menu, not in this screen. */
    var showCall = false;
    var list = EL(), limit = list && list.limitText ? list.limitText('form') : '';
    els.confirm.innerHTML =
      '<h3 class="mad-confirm__title" tabindex="-1">' + h(title) + '</h3>' +
      /* Seth 2026-10-13: no total while the prices switch is off */
      (W.showPrices() ? '<p class="mad-confirm__total"><span class="mad-estimate-bar__label">Estimate before freight' + (several ? ', each door' : '') + '</span> ' + h(money(est.total)) + '</p>' +
        (est.installReadyAdd ? '<p class="mad-confirm__text">With Install Ready: ' + h(money(est.totalWithInstallReady)) + '</p>' : '') : '') +
      '<p class="mad-confirm__text">' + h(W.freightText(false, st)) + (hold ? ' <span data-mad-hold>' + h(hold) + '</span>' : '') + '</p>' +
      /* R03: a browser that is not keeping the estimate says so here, before Review estimate or any other page change */
      (limit ? '<p class="mad-confirm__text mad-confirm__limit" data-mad-estimate-limit>' + h(limit) + '</p>' : '') +
      /* Seth 2026-10-10 (fewer clicks): Request your quote goes straight to the cart's quote form (#request-quote opens it,
         assets/mad-quote-form.js); Review estimate stays as a quiet link for anyone who wants to look first */
      '<div class="mad-confirm__actions"><a class="mad-btn mad-btn--primary" data-mad-finish-quote data-mad-request-quote href="' + h(cartUrl + '#request-quote') + '">Request your quote</a>' +
      '<button type="button" class="mad-btn mad-btn--secondary" data-mad-continue>Add another door</button></div>' +
      '<p class="mad-confirm__text mad-confirm__review"><a class="link" data-mad-finish-quote href="' + h(cartUrl) + '">Review estimate first</a></p>' +
      /* QA Q-09: the phone is mad_phone (the hold sentence no longer carries one) and never wraps mid-number */
      (showCall ? '<p class="mad-confirm__call">Prefer to talk now? <a href="' + h(phoneHref) + '" style="white-space:nowrap">' + h(phone) + '</a></p>' : '');
    els.confirm.hidden = false;
    /* Clarity event (Seth 2026-10-10): a door with its choices reached the estimate (an update of a door already on it
       is not a new one) */
    if (!updated) { try { if (typeof window.madClarityEvent === 'function') window.madClarityEvent('estimate_added'); else if (typeof window.clarity === 'function') window.clarity('event', 'estimate_added'); } catch (e) { /* ignore */ } }
    var t = els.confirm.querySelector('.mad-confirm__title'); if (t) t.focus({ preventScroll: true });
  }
  /* Seth, 2026-09-26: "one of one" is said of antiques only. A handcrafted door is stock, so its review and added
     screens say nothing about holds; an owner's saved sentence that opens "Every door" is read as the antique rule. */
  function holdFor(st) {
    var hold = st.kind === 'antique' ? String(cfg.holdText || 'There is only one of each antique door, and it goes to the first completed payment.').replace(/^Every door\b/, 'Every antique door') : '';
    return hold;
  }

  /* ---------- "Review your door" (Seth 2026-10-12) ----------
     Every answer by its customer name (MADEstimate.CHOICE_NAMES), in three groups that each go back to their step with
     "Change" (and return here), then the price: the door first, each service, the total, the freight sentence for this
     page (no dollar range on collection pages) and, for an antique, the one-of-one sentence. It only reads the state:
     showing it changes nothing that is saved. */
  function NM(q, v) { var t = ((E().CHOICE_NAMES || {})[q]) || {}; return t[v] || v || ''; }
  function reviewGroups(st) {
    var raw = W.buildRaw(st), plan = W.planFor(st), groups = [], rows;
    var noJamb = raw.application === 'sliding_barn' || raw.application === 'pocket_door' || raw.application === 'decorative';
    rows = [['Where', NM('int_ext', raw.int_ext)]];
    if (raw.not_measured === '1' || raw.opening_type === 'none') rows.push(['Size', NM('opening_type', 'none')]);
    else {
      rows.push([NM('opening_type', raw.opening_type), (raw.rough_opening || raw.finished_opening || '') + ' in']);
      var noSize = raw.fit_readout === 'talk' && !st.slab;
      rows.push(['Fit', noSize ? (E().SIZE_TO_CONFIRM || 'Size to be confirmed') : NM('fit_readout', raw.fit_readout)]);
      if (raw.fit_readout === 'resize') rows.push(['Resize', raw.resize === 'yes' ? 'Yes, to ' + raw.target_width + ' x ' + raw.target_height + ' in' : NM('resize', 'no')]);
    }
    groups.push({ id: 'opening', title: 'Your opening', rows: rows });
    if (plan.indexOf('workshop') !== -1) {
      rows = [];
      if (st.kind === 'antique') rows.push(['Restoration', NM('restore_tier', E().tierFromRaw(raw, BOOK()))]);
      if (raw.int_ext !== 'exterior') rows.push(['Wax finish', NM('wax_finish', raw.wax_finish || 'none')]);
      if (st.kind === 'antique' && st.flags.glass) {
        rows.push(['Glass', NM('glass_work', raw.glass_work || 'none')]);
        if (raw.glass_compliance === '1') rows.push(['Glass notice', 'Read and accepted']);
      }
      groups.push({ id: 'workshop', title: 'Workshop choices', rows: rows });
    }
    rows = [['Opens', NM('application', raw.application || 'standard_hinged')]];
    /* no Pair row (Seth 2026-10-13): it follows Interior or Exterior and the swing says it */
    rows.push(['Frame', noJamb ? NM('jamb_needed', 'no') : NM('jamb_needed', raw.jamb_needed)]);
    if (raw.jamb_needed === 'yes') {
      var sv = window.MadSwingSVG, d = sv && raw.swing ? sv.describe(raw.swing) : null;
      rows.push(['Wall thickness', raw.wall_depth === 'other' ? (raw.wall_depth_custom || '') + ' in' : NM('wall_depth', raw.wall_depth)]);
      rows.push(['Swing', d ? (d.plain || d.name) + (d.code ? ' (' + d.code + ')' : '') : String(raw.swing || '').toUpperCase()]);
      rows.push(['Hinge finish', NM('hinge_color', raw.hinge_color)]);
      if (raw.latch_type) rows.push(['Latch', NM('latch_type', raw.latch_type)]);
      rows.push(['Frame wood', NM('jamb_grade', raw.jamb_grade)]);
    }
    groups.push({ id: 'hanging', title: 'How it hangs', rows: rows });
    return groups;
  }
  /* A door that moves from the payable cart to the estimate says so (a /cart line, or an antique in the cart opened from
     its card or the door page) */
  function moveNote(st) {
    if (!EL()) return '';
    if (st.mode === 'cart-move') return st.kind !== 'antique' && !st.existingId && st.units > 1 ? 'All ' + st.units + ' doors move from your cart to your estimate, each at this price.' : 'Moves from your cart to your estimate.';
    return st.ui.inCart ? 'Moves from your cart to your estimate.' : '';
  }
  function renderReview(st) {
    var rows = W.priceRows(st, { doorName: true }), est = W.estimateForRaw(W.buildRaw(st), st.product), hold = holdFor(st), move = moveNote(st);
    return '<div class="mad-review" data-mad-review>' +
      (move ? '<p class="mad-review__note mad-review__move" data-mad-review-move>' + h(move) + '</p>' : '') +
      reviewGroups(st).map(function (g) {
        return '<section class="mad-review__group" data-mad-review-group="' + g.id + '"><div class="mad-review__head"><h4 class="mad-review__title">' + h(g.title) + '</h4>' +
          '<button type="button" class="mad-review__change" data-mad-change="' + g.id + '" aria-label="Change ' + h(g.title) + '">Change</button></div>' +
          '<dl class="mad-review__list">' + g.rows.map(function (r) { return '<div class="mad-review__row"><dt>' + h(r[0]) + '</dt><dd>' + h(r[1]) + '</dd></div>'; }).join('') + '</dl></section>';
      }).join('') +
      '<div class="mad-review__side">' +
      /* Seth 2026-10-13: the price table only while the prices switch is on; the quote carries every price */
      (W.showPrices() ? '<table class="mad-price-table" data-mad-review-prices><caption class="visually-hidden">Price</caption><tbody>' +
        rows.map(function (r) { return '<tr data-mad-price-line="' + h(r.key) + '"><th scope="row">' + h(r.label) + '</th><td>' + h(r.pending ? 'Priced on your quote' : money(r.amount)) + '</td></tr>'; }).join('') +
      '</tbody><tfoot><tr><th scope="row">Estimate before freight</th><td data-mad-review-total>' + h(money(est.total)) + '</td></tr></tfoot></table>' : '') +
      '<p class="mad-review__note" data-mad-review-freight>' + h(W.freightText(false, st)) + '</p>' +
      (hold ? '<p class="mad-review__note" data-mad-hold>' + h(hold) + '</p>' : '') +
      '</div></div>';
  }
  if (typeof W.registerStep === 'function') W.registerStep('review', {
    title: 'Review your door', short: 'Review', topics: ['review'],
    render: renderReview, check: function () { return []; }
  });

  doc.addEventListener('click', function (e) {
    if (e.target.closest('[data-mad-continue]')) { e.preventDefault(); W.close('done'); return; }
    /* Request your quote on the added screen links to /cart#request-quote; on the cart page itself only the hash
       changes (assets/mad-quote-form.js opens the request on hashchange), so the form steps aside first */
    var fin = e.target.closest('#mad-wizard [data-mad-finish-quote]');
    if (fin && W.isOpen()) { try { if (new URL(fin.href, location.href).pathname === location.pathname) W.close('done'); } catch (_) { /* old browsers: the link goes on */ } }
  });
  /* An antique opened from its card or the door page that is also in the Shopify cart: Review says it moves */
  doc.addEventListener('mad:wizard:opened', function () {
    var st = W.state();
    if (!st || st.mode === 'cart-move' || (st.mode === 'cart-edit' && !st.ui.already) || st.kind !== 'antique') return;
    cartLineOf(st.product).then(function (line) {
      if (!line || W.state() !== st) return;
      st.ui.inCart = line.key;
      /* Review may already be showing (an antique already on the estimate lands there): draw it again with the note */
      if (st.at === 'review' && W.isOpen()) W.goTo('review');
    });
  });

  /* ---------- product page glue ---------- */
  function initPdp() {
    var product = W.productFromElement(null);
    if (!product || !E()) { doc.querySelectorAll('[data-mad-door-only]').forEach(function (el) { el.remove(); }); return; }
    var config = W.doorConfig(product) || 'single', flags = W.doorFlags(product);
    /* A "from" teaser is rounded UP to whole dollars (QA P-08: "from $986.55" on arched doors); the
       estimate lines keep the exact figure, which matches the Zap. */
    var from = Math.ceil(Math.round(E().installReadyFrom(config, flags, BOOK()) * 100) / 100);
    var label = (E().CONFIG_LABELS[config] || 'single').toLowerCase().replace(' door', '').replace(' set', '');
    doc.querySelectorAll('[data-mad-install-ready-from]').forEach(function (el) { el.textContent = 'Install Ready from ' + money(from) + ' (' + label + ', interior)'; });
    doc.querySelectorAll('[data-mad-sticky-price]').forEach(function (el) { el.textContent = money(product.price / 100); });
    doc.querySelectorAll('[data-mad-sticky-from]').forEach(function (el) { el.textContent = 'Install Ready from ' + money(from); });
    if (doc.querySelector('[data-mad-sticky-cta]') && product.available !== false) {
      doc.body.classList.add('mad-has-sticky-cta');
      doc.documentElement.classList.add('mad-has-sticky-cta');
    }
  }
  /* Registered at load, not after MadWizard.ready: the glass notice must guard Buy door only even when the
     estimate scripts fail to start. Document listeners, so a re-rendered product section stays guarded. */
  function bindPdpGuards() {
    /* Buy door only on antique + Glass: require the non-tempered ack before the product form submits.
       Checked on the document in the capture phase, so it runs before the theme's product-form handler
       in every browser. QA P-02 (2026-09-25): a blocked tap must never look like nothing happened. The
       notice can be far above the phone bottom bar, so it is scrolled into view, the box is focused (its
       description reads the notice and the message) and the message goes into the notice's live region. */
    doc.addEventListener('submit', function (e) {
      var form = e.target, ack = form && form.querySelector ? form.querySelector('[data-mad-buy-as-is-glass]') : null;
      if (!ack || ack.checked) return;
      e.preventDefault();
      e.stopPropagation();
      showGlassAck(form);
    }, true);
    doc.addEventListener('change', function (e) {
      var ack = e.target;
      if (!ack || !ack.matches || !ack.matches('[data-mad-buy-as-is-glass]') || !ack.checked) return;
      var form = ack.closest('form'); if (form) clearGlassAck(form);
    });
    /* The phone bottom bar: on a glass antique it checks the box first; unticked, it takes the customer to
       the notice instead of clicking a button that would be blocked out of sight. */
    doc.addEventListener('click', function (e) {
      var sticky = e.target.closest('[data-mad-sticky-buy-as-is]');
      if (!sticky) return;
      e.preventDefault();
      var add = doc.querySelector('[data-mad-buy-as-is]');
      if (!add) return;
      var form = formFor(add), ack = form ? form.querySelector('[data-mad-buy-as-is-glass]') : null;
      if (ack && !ack.checked) { showGlassAck(form); return; }
      if (!add.disabled) add.click();
      else scrollToCenter(add);
    });
  }
  /* the page's own words come from data-mad-glass-ack-message (snippets/buy-buttons.liquid); this is the fallback */
  var GLASS_ACK_MESSAGE = 'Please tick the box to confirm you have read the glass notice, then choose Add to cart again.';
  function formFor(el) { return el.closest('form') || doc.getElementById(el.getAttribute('form')); }
  function scrollToCenter(el) {
    var reduce = false;
    try { reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (_) { /* default motion */ }
    try { el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (_) { el.scrollIntoView(); }
  }
  function showGlassAck(form) {
    var ack = form.querySelector('[data-mad-buy-as-is-glass]'), host = form.querySelector('[data-mad-pdp-glass-ack]');
    if (host) {
      host.setAttribute('data-tone', 'error');
      var msg = host.querySelector('[data-mad-glass-ack-error]');
      if (msg) {
        /* Emptied first and written a moment later, so a screen reader announces every blocked tap, not
           only the first (many do not re-read an alert whose text did not change). QA P-02 review. */
        clearTimeout(msg.madAckTimer);
        msg.textContent = '';
        msg.madAckTimer = setTimeout(function () {
          if (!ack || !ack.checked) msg.textContent = host.getAttribute('data-mad-glass-ack-message') || GLASS_ACK_MESSAGE;
        }, 50);
      }
      scrollToCenter(host);
    } else if (ack) scrollToCenter(ack);
    if (ack) { ack.setAttribute('aria-invalid', 'true'); ack.focus({ preventScroll: true }); }
  }
  function clearGlassAck(form) {
    var ack = form.querySelector('[data-mad-buy-as-is-glass]'), host = form.querySelector('[data-mad-pdp-glass-ack]');
    if (host) {
      host.removeAttribute('data-tone');
      var msg = host.querySelector('[data-mad-glass-ack-error]');
      if (msg) { clearTimeout(msg.madAckTimer); msg.textContent = ''; }
    }
    if (ack) ack.removeAttribute('aria-invalid');
  }
  bindPdpGuards();
  W.ready.then(initPdp);

  Object.assign(W, { buildProperties: buildProperties, addToCart: addToCart, updateLine: updateLine, removeLine: removeLine, moveToEstimate: moveToEstimate, cartLineOf: cartLineOf,
    updateCartIcon: updateCartIcon, quickRaw: quickRaw, estimateForCartItem: estimateForCartItem, parseRaw: parseRaw, fetchCart: fetchCart, labels: L });
})();
